module.exports = __webpack_public_path__ + "img/PayPal.c4a86dc3.svg";